import { useEffect } from 'react';

// Calls `handler` when Escape is pressed (while `active`). Cleans up on unmount.
// Used by modals so pressing Escape closes them consistently across the app.
export default function useEscapeKey(handler, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') handler(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [handler, active]);
}
